var map = {
	"./js/script.js": 39,
	"./sass/styles.scss": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;


//////////////////
// WEBPACK FOOTER
// ./src/wp-migrate-db-pro-multisite-tools/asset/src ./node_modules/imports-loader?$=>window.jQuery ^(.*\.(js|sass|scss$))/i
// module id = 38
// module chunks = 0